export function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm z-[1000] min-h-screen">
      <div className="animate-spin rounded-full h-14 w-14 border-4 border-yellow-400 border-t-transparent"></div>
    </div>
  );
}
